
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger,
  DropdownMenuSeparator
} from "@/components/ui/dropdown-menu";
import { Menu, User, LayoutDashboard, LogOut, Shield, Map } from "lucide-react";

const NavbarActions = () => {
  const { user, userRole, signOut } = useAuth();

  return (
    <div className="flex items-center gap-3">
      {/* Menu dropdown - show to all users */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon">
            <Menu className="h-5 w-5" />
            <span className="sr-only">Menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48 bg-white">
          {/* Show Crime Map to all users */}
          <DropdownMenuItem onSelect={() => window.location.href = "/crime-map"}>
            <Map className="mr-2 h-4 w-4" />
            <span>Crime Map</span>
          </DropdownMenuItem>
          
          {/* Show Report Crime to all users */}
          <DropdownMenuItem onSelect={() => window.location.href = "/report-crime"}>
            <Shield className="mr-2 h-4 w-4" />
            <span>Report Crime</span>
          </DropdownMenuItem>
          
          {/* Only show Dashboard to logged in vigilantes */}
          {user && userRole === "vigilante" && (
            <DropdownMenuItem onSelect={() => window.location.href = "/dashboard"}>
              <LayoutDashboard className="mr-2 h-4 w-4" />
              <span>Dashboard</span>
            </DropdownMenuItem>
          )}
          
          {/* Show user role and sign out only for logged in users */}
          {user && (
            <>
              {userRole && (
                <DropdownMenuItem disabled>
                  {userRole === "vigilante" ? (
                    <Shield className="mr-2 h-4 w-4 text-okkio-orange" />
                  ) : (
                    <User className="mr-2 h-4 w-4 text-blue-500" />
                  )}
                  <span>{userRole.charAt(0).toUpperCase() + userRole.slice(1)}</span>
                </DropdownMenuItem>
              )}
              
              <DropdownMenuSeparator />
              
              <DropdownMenuItem onSelect={signOut}>
                <LogOut className="mr-2 h-4 w-4" />
                <span>Sign Out</span>
              </DropdownMenuItem>
            </>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      
      {/* Only show Upgrade button for logged in users */}
      {user && (
        <Link to="/upgrade" className="hidden md:block">
          <Button className="bg-okkio-orange hover:bg-okkio-orange/90 text-white">
            Upgrade
          </Button>
        </Link>
      )}
    </div>
  );
};

export default NavbarActions;
